import { Select } from "antd";
import Title from "antd/es/typography/Title";
import { useFormikContext } from "formik";
import React, { FC } from "react";
import { ReportItem } from "shared/api";
import { isXlsOnlyReport } from "shared/helpers/reports";
import { ExecuteReportValues } from "shared/types";

const reportFormatOptions = [
  { label: "PDF", value: "pdf" },
  { label: "XLSX", value: "xlsx" },
  { label: "XLS", value: "xls" },
];

interface ReportFormatSelectProps {
  selectedReport?: ReportItem;
  clearPdfUrl?: () => void;
  titleClassName?: string;
}

//  Reports that can only ever be produced as XLS (custom carbone types) offer
//  no format choice — the selector is hidden and the format stays XLSX.
const ReportFormatSelect: FC<ReportFormatSelectProps> = ({
  selectedReport,
  clearPdfUrl,
  titleClassName = "!m-0 !text-start",
}) => {
  const { values, setFieldValue } = useFormikContext<ExecuteReportValues>();

  const handleReportFormatChange = (format: string) => {
    setFieldValue("report_format", format);
    if (clearPdfUrl) {
      clearPdfUrl();
    }
  };

  if (isXlsOnlyReport(selectedReport)) {
    return null;
  }

  return (
    <div className="flex gap-x-2">
      <Title level={5} className={titleClassName}>
        Report Format
      </Title>
      {" - "}
      <Select
        value={values.report_format}
        placeholder="Select Report Format"
        options={reportFormatOptions}
        onChange={handleReportFormatChange}
        className="w-[300px]"
        size="small"
      />
    </div>
  );
};

export { ReportFormatSelect };
